import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {
  
  date:any;
  loading: any;
  installments: any;
  installmentEdit: any;

  constructor(private authService: AuthenticationService) { }
  

  ngOnInit(): void {
    let date = new Date();
    let month = date.getMonth() + 1;
    this.date = date.getFullYear() + "-" + month;
    this.getInstallmentes();
  }

  getInstallmentes(){
    this.loading = true;
    console.log(this.date);
    let date = this.date.split('-');
    let data = {
      Month: date[1],
      Year: date[0],
    }
    console.log(data);
    this.authService.installementsByDate(data).then((res:any)=>{
      
      console.log(res);
      this.loading = false;
      this.installments = res;
      this.loading = false;
    }, (err:any)=>{
      console.log(err);
      this.loading = false;
    })
  }

  markPaid(installment:any){
    console.log(installment);
    this.installmentEdit = installment;
  }

}
